<template>
  <el-container direction="vertical" style="height: 100%; margin-left: 10px">
    <el-row class="mb-10" style="flex: 0 1 auto; margin-right: 10px">
      <el-col :span="24">
        <el-input
          v-model="kw"
          size="small"
          :placeholder="$t('AddMap.keyword')"
          class="input-with-select"
        >
          <template #append>
            <el-button
              icon="Search"
              class="btn-search"
              @click="searchMap"
              :loading="fetching"
            />
          </template>
        </el-input>
      </el-col>
    </el-row>

    <el-row class="mb-10 maplist-header">
      <div>
        <el-button
          size="small"
          text
          :bg="filterType == 'selected'"
          @click="showDDESelectedMaps"
          v-if="false"
        >
          {{ $t('AddMap.Select.SELECTED') }}
        </el-button>

        <el-button
          size="small"
          text
          :bg="filterType == 'starmapSelected'"
          @click="showStarmapSelectedMaps"
          v-if="!isDDE && !isDemo"
        >
          {{ $t('AddMap.Select.STARMAP_SELECTED') }}
        </el-button>

        <el-button
          size="small"
          text
          :bg="filterType == 'allPublic'"
          @click="showAllPublicMaps"
        >
          {{ $t('navigation.atlas') }}
        </el-button>

        <el-button
          size="small"
          text
          :bg="filterType == 'linked'"
          @click="showDDELinkedMaps"
          v-if="isDDE"
        >
          {{ $t('AddMap.Select.LINKED') }}
        </el-button>

        <el-button
          size="small"
          text
          :bg="filterType == 'private'"
          @click="showPrivateMaps"
          v-if="!isDDE"
        >
          {{ $t('AddMap.Select.PRIVATE') }}
        </el-button>
      </div>
      <div>
        <el-button class="switch-btn" link @click="toggleCondensed(false)">
          <i
            class="iconfont icon-list_thumb"
            :style="condensed ? null : { color: '#fc4c02' }"
          />
        </el-button>
        <el-button class="switch-btn" link @click="toggleCondensed(true)">
          <i
            class="iconfont icon-list"
            :style="condensed ? { color: '#fc4c02' } : null"
          />
        </el-button>
        <!-- <el-link
          class="small-link"
          target="_blank"
          :href="exploreUrl"
          v-show="!isDDE"
          >{{ $t('navigation.atlas') }}>></el-link
        > -->
      </div>
    </el-row>
    <p class="el-text notification-html" v-show="!showList">
      {{ $t('AddMap.notLogin') }}
      <el-link type="primary" :underline="false" @click="triggerLogin">
        {{ $t('AddMap.login') }}
      </el-link>
      &nbsp;{{ $t('AddMap.or') }}&nbsp;
      <el-link type="primary" :underline="false" @click="triggerLogin">
        {{ $t('AddMap.register') }}
      </el-link>
    </p>
    <div class="map-list-wrapper" v-if="showList">
      <el-row class="mb-10" :gutter="10">
        <el-col :span="condensed ? 24 : 12" v-for="(map, i) in maps" :key="i">
          <map-card :map="map" :condensed="condensed" :source="vuexModule" />
        </el-col>
      </el-row>
      <p
        class="el-text notification-html"
        v-html="emptyMapsHTML"
        style="padding: 60px 10px 0 0"
        v-show="totalEntries == 0 && !fetching"
      />
    </div>
    <el-row
      justify="end"
      style="flex: 0 1 40px; margin-right: 10px"
      v-if="showList"
    >
      <el-pagination
        :v-model:current-page="pageConf.currentPage"
        :page-size="resultsPerPage"
        layout="prev, pager, next"
        @current-change="onPagination"
        :total="totalEntries"
      />
      <div style="display: flex; align-items: center">
        <span style="margin-right: 8px; white-space: nowrap; font-size: 13px">{{
          $t('AddMap.goto')
        }}</span>
        <el-input
          v-model="current"
          size="small"
          style="width: 40px"
          @change="onPagination"
        />
      </div>
    </el-row>
  </el-container>
</template>
<script>
import { mapState } from 'vuex';
import MapCard from '@/components/maps/MapCard';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

const { track } = useTrack();
const { VUE_APP_CARTODB_SERVER } = process.env;
const VUE_APP_IS_DDE = process.env.VUE_APP_IS_DDE == 'true';
const VUE_APP_IS_DEMO = process.env.VUE_APP_IS_DEMO == 'true';
export default {
  components: { MapCard },
  data() {
    return {
      kw: '',
      filterType: (VUE_APP_IS_DEMO) ? 'allPublic' : (VUE_APP_IS_DDE ? 'allPublic' : 'starmapSelected'),
      condensed: false,
      pageConf: {
        currentPage: 1,
        small: false,
        background: false,
        disabled: false,
      },
      current: '',
      isDDE: !!VUE_APP_IS_DDE,
      isDemo: !!VUE_APP_IS_DEMO,
    };
  },
  methods: {
    triggerLogin() {
      $('.login-btn').click();
    },
    showAllPublicMaps() {
      this.filterType = 'allPublic';
      this.filterMaps();

      track(
        FunctionIdEnum.globalLayer_layers_listTypeSwitch,
        EventTypeEnum.CLICK,
        {
          type: 'public',
        },
      );
    },
    showPrivateMaps() {
      this.filterType = 'private';
      if (this.cartoAuthed) {
        this.filterMaps();
      }

      track(
        FunctionIdEnum.globalLayer_layers_listTypeSwitch,
        EventTypeEnum.CLICK,
        {
          type: 'private',
        },
      );
    },
    showDDESelectedMaps() {
      this.filterType = 'selected';
      this.filterMaps();

      track(
        FunctionIdEnum.globalLayer_layers_listTypeSwitch,
        EventTypeEnum.CLICK,
        {
          type: 'selected',
        },
      );
    },
    showStarmapSelectedMaps() {
      this.filterType = 'starmapSelected';
      this.filterMaps();
    },
    showDDELinkedMaps() {
      this.filterType = 'linked';
      this.filterMaps();

      track(
        FunctionIdEnum.globalLayer_layers_listTypeSwitch,
        EventTypeEnum.CLICK,
        {
          type: 'linked',
        },
      );
    },

    filterMaps() {
      if (this.isNewModule) {
        this.$store.dispatch(`${this.vuexModule}/fetchFilter`, {
          filterType: this.filterType,
          filterKeyword: this.kw,
        });
      } else {
        this.$store.dispatch(`${this.vuexModule}/filter`, {
          filter: this.filterType,
          keyword: this.kw,
        });
        this.$store.dispatch(`${this.vuexModule}/fetch`);
      }
    },

    searchMap() {
      track(
        FunctionIdEnum.globalLayer_layers_searchLayer,
        EventTypeEnum.SEARCH,
        {
          keyword: this.kw,
        },
      );
      this.filterMaps();
    },

    toggleCondensed(isCondensed) {
      this.condensed = isCondensed;

      track(
        FunctionIdEnum.globalLayer_layers_listStyleSwitch,
        EventTypeEnum.CLICK,
        {
          name: isCondensed ? 'list' : 'block',
        },
      );
    },
    onPagination(page) {
      if (this.isNewModule) {
        this.$store.dispatch(`${this.vuexModule}/fetchPage`, { page });
      } else {
        this.$store.dispatch(`${this.vuexModule}/setPagination`, page);
        this.$store.dispatch(`${this.vuexModule}/fetch`);
      }
      track(FunctionIdEnum.globalLayer_layers_gotoPage, EventTypeEnum.CLICK, {
        page,
      });
    },
  },

  computed: {
    ...mapState('auth', {
      cartoAuthed: (state) => state.cartoConfig,
    }),

    exploreUrl() {
      return `${VUE_APP_CARTODB_SERVER}/explore?locale=${this.$i18n.locale}`
    },

    emptyMapsHTML() {
      const CARTODB_SERVER = process.env.VUE_APP_CARTODB_SERVER;
      return this.$t('AddMap.nolayers', { url: `${CARTODB_SERVER}` });
    },

    showList() {
      return (
        this.cartoAuthed ||
        ['allPublic', 'linked', 'selected', 'starmapSelected'].includes(this.filterType)
      );
    },

    isNewModule() {
      return this.vuexModule === 'selectedMaps' || this.vuexModule === 'starmapSelected';
    },

    maps() {
      if (this.isNewModule) {
        return this.$store.state[this.vuexModule].list;
      }
      return this.$store.state[this.vuexModule].list;
    },

    page() {
      if (this.isNewModule) {
        return this.$store.state[this.vuexModule].pagination.page;
      }
      return this.$store.state[this.vuexModule].page;
    },

    resultsPerPage() {
      if (this.isNewModule) {
        return this.$store.state[this.vuexModule].pagination.perPage;
      }
      return this.$store.state[this.vuexModule].resultsPerPage;
    },

    totalEntries() {
      if (this.isNewModule) {
        return this.$store.state[this.vuexModule].pagination.totalEntities;
      }
      return this.$store.state[this.vuexModule].metadata.total_entries;
    },

    fetching() {
      if (this.isNewModule) {
        return this.$store.state[this.vuexModule].fetchable.isFetching;
      }
      return this.$store.state[this.vuexModule].isFetching;
    },

    vuexModule() {
      let module = 'maps';
      if (this.filterType === 'linked') {
        module = 'datahubLayers';
      }
      if (this.filterType === 'selected') {
        module = 'selectedMaps';
      }
      if (this.filterType === 'starmapSelected') {
        module = 'starmapSelected';
      }
      return module;
    },
  },
  created() {
    this.filterMaps();
  },
};
</script>
<style scoped type="scss">
.maplist-header {
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-12 {
  margin-bottom: 12px;
}
.btn-search {
  margin: 0;
}

.align-right {
  text-align: right;
}

.input-with-select {
  width: 100%;
}

.map-list-wrapper {
  overflow-x: hidden;
  flex: 1 1 auto;
  overflow-y: auto;
  padding-right: 10px;
}
.notification-html {
  padding: 60px 10px 0 0;
  .el-link {
    vertical-align: baseline !important;
  }
}
.small-link {
  font-size: 12px;
}
.switch-btn {
  margin: 0 5px 0 0 !important;
}
</style>
